'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
// This could potentially instead be associated with element types
var MEDIA_STORAGE_URL = exports.MEDIA_STORAGE_URL = 'https://media.milanote.com/';
var MEDIA_STORAGE_BUCKET = exports.MEDIA_STORAGE_BUCKET = 'milanote';

var FILE_TYPES = exports.FILE_TYPES = {
    IMAGE: {
        name: 'image',
        mimePattern: /^image\/(png|gif|jpe?g)/g,
        maxSize: 10 * 1024 * 1024
    }
};


//////////////////
// WEBPACK FOOTER
// ./src/common/utils/fileUploadConstants.js
// module id = 2290
// module chunks = 0